export default {
  DEFAULT_TEMPLATE_LOCALE: 'en',
  SOCIAL_ICON_DEFAULT: 'fallback',
  HEADER_CODE: 'headerCode',
  FOOTER_CODE: 'footerCode',
  PAGE_FOOTER_CODE_ELEMENT_ID: 'ws-page-footer-code',
  PAGE_HEADER_CODE_ELEMENT_ID: 'ws-page-header-code',
  SITE_FOOTER_CODE_ELEMENT_ID: 'ws-site-footer-code',
  SITE_HEADER_CODE_ELEMENT_ID: 'ws-site-header-code',
  SHOP_PAGE_TEMPLATE: 'shop',
};
